import { concat } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { eq, not } from 'ember-truth-helpers';

const VARIANT_SORTING = [
  '100',
  '100italic',
  '200',
  '200italic',
  '300',
  '300italic',
  'regular',
  'italic',
  '500',
  '500italic',
  '600',
  '600italic',
  '700',
  '700italic',
  '800',
  '800italic',
  '900',
  '900italic',
];

export default class PageBuilderOptionsFont extends Component {
  // Services
  @service googleFonts;
  @service intl;

  // Getter and setter
  get fontSizes() {
    return [
      { value: 'xs', label: 'xs' },
      { value: 's', label: 's' },
      { value: 'm', label: 'm' },
      { value: 'l', label: 'l' },
      { value: 'xl', label: 'xl' },
    ];
  }

  get v1FontStyles() {
    const scope = 'forms.defaults.options.fontStyles';

    return [
      {
        value: 'light',
        label: this.intl.t(`${scope}.light`),
      },
      {
        value: 'light italic',
        label: this.intl.t(`${scope}.light_italic`),
      },
      {
        value: 'regular',
        label: this.intl.t(`${scope}.regular`),
      },
      {
        value: 'regular italic',
        label: this.intl.t(`${scope}.regular_italic`),
      },
      {
        value: 'bold',
        label: this.intl.t(`${scope}.bold`),
      },
      {
        value: 'bold italic',
        label: this.intl.t(`${scope}.bold_italic`),
      },
      {
        value: 'extra bold',
        label: this.intl.t(`${scope}.extra_bold`),
      },
      {
        value: 'extra bold italic',
        label: this.intl.t(`${scope}.extra_bold_italic`),
      },
    ];
  }

  get v2FontStyles() {
    const selectedFont = this.siteFonts.find((font) => {
      return (
        font.familyWithFallback ===
        this.args.fieldset.model.get(`options.${this.args.prefix}Family`)
      );
    });

    const sortedVariants = selectedFont?.variants?.sort((a, b) => {
      return VARIANT_SORTING.indexOf(a) > VARIANT_SORTING.indexOf(b);
    });

    return sortedVariants?.map((variant) => {
      return {
        value: variant,
        label: variant,
      };
    });
  }

  get fontStyles() {
    if (this.args.mlp.isV2) {
      return this.v2FontStyles;
    }

    return this.v1FontStyles;
  }

  get siteFonts() {
    if (this.args.mlp.isV2) {
      return this.args.mlp.get('options.fontFamiliesToLoad') ?? [];
    }

    return this.googleFonts.items;
  }

  selectFontFamily = (selectedFont) => {
    const family = this.args.mlp.isV2
      ? selectedFont?.familyWithFallback
      : selectedFont?.family;

    const style = selectedFont ? 'regular' : null;

    this.args.fieldset.model.set(`options.${this.args.prefix}Family`, family);
    this.args.fieldset.model.set(`options.${this.args.prefix}Style`, style);
  };

  // Template
  <template>
    <@fieldset.field
      @property={{concat 'options.' @prefix 'Family'}}
      @type='select-value'
      @labelProperty='family'
      @isSearchEnabled={{not @mlp.isV2}}
      @searchField='family'
      @selectPath={{if @mlp.isV2 'familyWithFallback' 'family'}}
      @options={{this.siteFonts}}
      @onChange={{this.selectFontFamily}}
    />

    <@fieldset.field
      @property={{concat 'options.' @prefix 'Style'}}
      @type='select-value'
      @options={{this.fontStyles}}
      @disabled={{eq this.fontStyles.length 0}}
    />
    <@fieldset.field
      @property={{concat 'options.' @prefix 'Size'}}
      @type='select-value'
      @options={{this.fontSizes}}
    />
  </template>
}
